/*
 * hcl-flyers.js
 * Products drift across the holiday lander one at a time, following design's
 * "Landing Page v2" prototype: curved paths that never cross the form (or the
 * countdown after signup), a fixed width per product capped at 42% of the
 * screen's width and half its height, and the next one 2-6s after the last
 * leaves. Every product shows once before any repeats. Hovering (or focusing)
 * one pauses it and shows a bullseye; clicking or tapping opens its info card,
 * joined to the bullseye by an elbow leader. Escape or a click elsewhere closes
 * the card and the product flies on.
 * Reduced motion: products sit still in the corners and still open their card.
 */
(function () {
  var root = document.querySelector('[data-hcl]');
  if (!root) return;

  var stage = root.querySelector('[data-hcl-stage]');
  var card = root.querySelector('[data-hcl-card]');
  var cardTitle = card.querySelector('[data-hcl-card-title]');
  var cardBody = card.querySelector('[data-hcl-card-body]');
  var sticker = card.querySelector('[data-hcl-card-sticker]');
  var stickerText = card.querySelector('[data-hcl-card-sticker-text]');
  var closeBtn = card.querySelector('[data-hcl-card-close]');
  var leader = root.querySelector('[data-hcl-leader]');
  var leaderLine = leader.querySelector('polyline');
  var EVERY = 8000;

  var products = [];
  try {
    products = JSON.parse(root.querySelector('[data-hcl-products]').textContent || '[]');
  } catch (e) {}
  products = products.filter(function (p) { return p && p.src; });
  if (!products.length) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  var target = document.createElement('button');
  target.type = 'button';
  target.className = 'hcl-target';
  target.hidden = true;
  root.appendChild(target);

  var flights = [];
  var bag = [];
  var last = -1;
  var timer = 0;
  var active = null;
  var openFor = null;
  var lastFocus = null;
  var running = false;

  function nextProduct() {
    if (!bag.length) {
      bag = products.map(function (_, i) { return i; }).sort(function () { return Math.random() - 0.5; });
      if (bag[0] === last && bag.length > 1) bag.push(bag.shift());
    }
    last = bag.shift();
    return products[last];
  }

  function bez(a, b, c, t) {
    return (1 - t) * (1 - t) * a + 2 * (1 - t) * t * b + t * t * c;
  }

  function rel(r) {
    var s = root.getBoundingClientRect();
    return { l: r.left - s.left, t: r.top - s.top, r: r.right - s.left, b: r.bottom - s.top };
  }

  /* What flights keep clear of: the form, or the countdown (or button) after signup. */
  function avoidBox(margin) {
    var el = root.querySelector('[data-hcl-view]:not([hidden]) [data-hcl-form], [data-hcl-view]:not([hidden]) [data-hcl-count]:not([hidden]), [data-hcl-view]:not([hidden]) .hcl__cta');
    if (!el || !el.offsetParent) return null;
    var b = rel(el.getBoundingClientRect());
    return { l: b.l - margin, t: b.t - margin, r: b.r + margin, b: b.b + margin };
  }

  function pickPath(W, H, pw) {
    var box = avoidBox(pw * 0.55 + 16);
    for (var i = 0; i < 40; i++) {
      var fromLeft = Math.random() < 0.5;
      var off = pw * 0.8;
      var y0 = H * (0.05 + Math.random() * 0.85);
      var mag = H * (Math.random() < 0.1 ? 0.12 + Math.random() * 0.1 : 0.3 + Math.random() * 0.35);
      var y2 = y0 + (Math.random() < 0.5 ? -mag : mag);
      if (y2 < -H * 0.05 || y2 > H * 1.05) y2 = y0 - (y2 - y0);
      var x0 = fromLeft ? -off : W + off;
      var x2 = fromLeft ? W + off : -off;
      var x1 = (x0 + x2) / 2;
      var y1 = (y0 + y2) / 2;
      var ok = true;
      if (box) {
        for (var k = 0; k <= 80; k++) {
          var t = k / 80;
          var x = bez(x0, x1, x2, t);
          var y = bez(y0, y1, y2, t);
          if (x > box.l && x < box.r && y > box.t && y < box.b) { ok = false; break; }
        }
      }
      if (ok) return { x0: x0, y0: y0, x1: x1, y1: y1, x2: x2, y2: y2, fromLeft: fromLeft };
    }
    return null;
  }

  function makeButton(p, pw) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hcl-flyer';
    btn.style.width = pw + 'px';
    btn.style.marginLeft = -pw / 2 + 'px';
    btn.style.marginTop = -(pw / (p.ratio || 1)) / 2 + 'px';
    btn.setAttribute('aria-label', (p.name || p.title || 'Product') + ': more info');
    var img = document.createElement('img');
    img.src = p.src;
    img.alt = '';
    img.decoding = 'async';
    btn.appendChild(img);
    return btn;
  }

  /* ---- Target circle + card --------------------------------------------- */

  function targetPoint(f) {
    var w = f.pw;
    var h = w / (f.p.ratio || 1);
    var lx = ((f.p.targetX || 50) / 100 - 0.5) * w;
    var ly = ((f.p.targetY || 50) / 100 - 0.5) * h;
    var a = (f.rot || 0) * Math.PI / 180;
    var sx = f.flip ? -1 : 1;
    lx *= sx;
    return { x: f.x + lx * Math.cos(a) - ly * Math.sin(a), y: f.y + lx * Math.sin(a) + ly * Math.cos(a) };
  }

  function holdFlight(f) {
    if (active && active !== f) releaseFlight(active);
    active = f;
    f.paused = true;
    var pt = targetPoint(f);
    target.style.left = pt.x + 'px';
    target.style.top = pt.y + 'px';
    target.setAttribute('aria-label', 'Open ' + (f.p.title || f.p.name || 'product') + ' info');
    target.hidden = false;
  }

  function releaseFlight(f) {
    if (openFor === f) closeCard(false);
    if (active === f) {
      active = null;
      target.hidden = true;
    }
    f.paused = false;
  }

  /* A hover-opened card leaves focus alone (so it can't pull focus out of the email
     field) and closes again when the mouse moves off. */
  function openCard(f, viaHover) {
    holdFlight(f);
    openFor = f;
    f.hoverOpen = !!viaHover;
    f.overCard = false;
    if (!viaHover) lastFocus = document.activeElement;
    cardTitle.textContent = f.p.title || '';
    cardBody.textContent = f.p.body || '';
    stickerText.textContent = f.p.sticker || '';
    sticker.hidden = !f.p.sticker;
    card.hidden = false;
    target.classList.add('is-open');
    placeCard(f);
    window.HCL && window.HCL.track('product_card_open', { product: f.p.title || f.p.name || '' });
    if (!viaHover) card.focus({ preventScroll: true });
  }

  /* The prototype's layout: card beside the bullseye on the side with more room,
     raised above it (or dropped below near the top), with an elbow leader. Phones
     stack the card above or below instead, since a near-full-width card would hide a
     sideways elbow. Either way, the first spot that keeps clear of the form wins. */
  function placeCard(f) {
    var pt = targetPoint(f);
    var W = root.clientWidth;
    var H = root.clientHeight;
    var cw = card.offsetWidth;
    var ch = card.offsetHeight;
    var box = avoidBox(12);
    var spots = [];
    function spot(left, top, side) {
      left = Math.max(16, Math.min(W - cw - 24, left));
      top = Math.max(16, Math.min(H - ch - 16, top));
      spots.push({ left: left, top: top, side: side });
    }

    if (W < 640) {
      var mLeft = pt.x - cw / 2;
      var belowFirst = pt.y < H / 2;
      [63, 36].forEach(function (gap) {
        spot(mLeft, belowFirst ? pt.y + gap : pt.y - gap - ch, belowFirst ? 'below' : 'above');
        spot(mLeft, belowFirst ? pt.y - gap - ch : pt.y + gap, belowFirst ? 'above' : 'below');
      });
    } else {
      var right = pt.x < W / 2;
      var raised = pt.y - 175 < 50 ? pt.y + 63 : pt.y - 175;
      [right, !right].forEach(function (r) {
        var left = r ? pt.x + 50 : pt.x - 50 - cw;
        [raised, pt.y - 175, pt.y + 63, pt.y - ch + 30].forEach(function (top) {
          spot(left, top, r ? 'right' : 'left');
        });
      });
    }

    /* Covering the bullseye (once clamped to the screen edge) is worse than touching the form. */
    var bull = { l: pt.x - 30, t: pt.y - 30, r: pt.x + 30, b: pt.y + 30 };
    /* On phones the sticker hangs off the card's bottom-right corner, so keep that clear of the form too. */
    var hang = !sticker.hidden && W < 640 ? sticker.getBoundingClientRect().bottom - card.getBoundingClientRect().bottom : 0;
    hang = Math.max(0, hang);
    var best = spots[0];
    var bestHit = Infinity;
    for (var i = 0; i < spots.length; i++) {
      var hit = (box ? overlap(spots[i], cw, ch + hang, box) : 0) + (overlap(spots[i], cw, ch, bull) ? 1e7 : 0);
      if (hit < bestHit) { best = spots[i]; bestHit = hit; }
      if (!hit) break;
    }

    card.style.left = best.left + 'px';
    card.style.top = best.top + 'px';
    var points;
    if (best.side === 'below' || best.side === 'above') {
      points = pt.x + ',' + pt.y + ' ' + pt.x + ',' + (best.side === 'below' ? best.top : best.top + ch);
    } else {
      var midY = best.top + 49;
      var edge = best.side === 'right' ? best.left : best.left + cw;
      points = pt.x + ',' + pt.y + ' ' + pt.x + ',' + midY + ' ' + edge + ',' + midY;
    }
    leaderLine.setAttribute('points', points);
    leader.removeAttribute('hidden');
  }

  function overlap(s, cw, ch, box) {
    var x = Math.min(s.left + cw, box.r) - Math.max(s.left, box.l);
    var y = Math.min(s.top + ch, box.b) - Math.max(s.top, box.t);
    return x > 0 && y > 0 ? x * y : 0;
  }

  function closeCard(returnFocus) {
    if (!openFor) return;
    card.hidden = true;
    target.classList.remove('is-open');
    leader.setAttribute('hidden', '');
    var f = openFor;
    openFor = null;
    f.hoverOpen = false;
    if (returnFocus && lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
    if (!f.hovering && !f.focused) releaseFlight(f);
  }

  target.addEventListener('click', function () {
    if (active) openCard(active);
  });
  target.addEventListener('pointerenter', function () {
    if (active) active.overTarget = true;
  });
  target.addEventListener('pointerleave', function () {
    if (!active) return;
    active.overTarget = false;
    maybeRelease(active);
  });
  card.addEventListener('pointerenter', function () {
    if (openFor) openFor.overCard = true;
  });
  card.addEventListener('pointerleave', function () {
    if (!openFor) return;
    openFor.overCard = false;
    maybeRelease(openFor);
  });
  /* Dismiss and let the product fly on: the bullseye and leader go with it. */
  function dismissCard() {
    var f = openFor;
    if (!f) return;
    f.hovering = false;
    f.focused = false;
    closeCard(false);
    releaseFlight(f);
  }

  /* A tap or click on the X behaves like tapping outside the card. From the
     keyboard (detail 0), focus goes back to the product instead, which holds it. */
  closeBtn.addEventListener('click', function (e) {
    if (e.detail === 0) closeCard(true);
    else dismissCard();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openFor) closeCard(true);
  });
  document.addEventListener('pointerdown', function (e) {
    if (!openFor) return;
    if (card.contains(e.target) || e.target === target || (openFor.el && openFor.el.contains(e.target))) return;
    dismissCard();
  });

  /* A hover-opened card gets a longer grace so the mouse can cross the gap to it. */
  function maybeRelease(f) {
    setTimeout(function () {
      if ((openFor === f && !f.hoverOpen) || f.hovering || f.focused || f.overTarget || f.overCard) return;
      releaseFlight(f);
    }, f.hoverOpen ? 300 : 120);
  }

  function wire(f) {
    var el = f.el;
    el.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      f.hovering = true;
      holdFlight(f);
      /* Open after a beat, so a product drifting under a resting cursor doesn't flash a card. */
      clearTimeout(f.hoverTimer);
      f.hoverTimer = setTimeout(function () {
        if (f.hovering && openFor !== f) openCard(f, true);
      }, 150);
    });
    el.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      f.hovering = false;
      clearTimeout(f.hoverTimer);
      maybeRelease(f);
    });
    el.addEventListener('focus', function () {
      f.focused = true;
      holdFlight(f);
    });
    el.addEventListener('blur', function () {
      f.focused = false;
      maybeRelease(f);
    });
    /* Clicking a hover-opened card pins it open rather than closing it. */
    el.addEventListener('click', function () {
      if (openFor === f && f.hoverOpen) {
        f.hoverOpen = false;
        lastFocus = el;
        card.focus({ preventScroll: true });
      } else if (openFor === f) closeCard(true);
      else openCard(f);
    });
  }

  /* ---- Flight ------------------------------------------------------------- */

  /* A product's phone width may fill up to 80% of the screen, so the Contact Keeper
     and phone can stay about twice the charms' size on phones (ENG-2264). */
  function sizeFor(p) {
    var W = root.clientWidth;
    var phone = W < 640 && p.mobileSize;
    return Math.min(phone || p.size || 240, W * (phone ? 0.8 : 0.42), root.clientHeight * 0.5);
  }

  function scheduleNext(delay) {
    clearTimeout(timer);
    if (running) timer = setTimeout(launch, delay);
  }

  /* One product at a time: launch only once the last has gone (or retry shortly). */
  function launch() {
    if (!running) return;
    if (document.hidden || flights.length || openFor) { scheduleNext(800); return; }

    var W = root.clientWidth;
    var H = root.clientHeight;
    var p = nextProduct();
    var pw = sizeFor(p);
    var path = pickPath(W, H, pw);
    if (!path) { bag.unshift(last); scheduleNext(800); return; }

    var el = makeButton(p, pw);
    stage.appendChild(el);
    var dir = path.fromLeft ? 1 : -1;
    var f = {
      p: p, el: el, pw: pw, path: path, paused: false,
      dur: 7500 + Math.random() * 2500,
      r0: Math.random() * 40 - 20,
      spin: (50 + Math.random() * 50) * dir,
      flip: (p.faces === 'right' && dir < 0) || (p.faces === 'left' && dir > 0),
      t: 0, prev: null,
    };
    wire(f);
    flights.push(f);
  }

  function frame(now) {
    if (!running) return;
    for (var i = flights.length - 1; i >= 0; i--) {
      var f = flights[i];
      if (f.prev === null) f.prev = now;
      var dt = now - f.prev;
      f.prev = now;
      if (!f.paused) f.t += dt / f.dur;
      if (f.t >= 1) {
        if (active === f) { active = null; target.hidden = true; }
        if (openFor === f) closeCard(false);
        f.el.remove();
        flights.splice(i, 1);
        if (!flights.length) scheduleNext(EVERY * (0.25 + Math.random() * 0.5));
        continue;
      }
      var P = f.path;
      f.x = bez(P.x0, P.x1, P.x2, f.t);
      f.y = bez(P.y0, P.y1, P.y2, f.t);
      f.rot = f.r0 + f.spin * f.t;
      f.el.style.transform = 'translate(' + f.x + 'px,' + f.y + 'px) rotate(' + f.rot + 'deg)' + (f.flip ? ' scaleX(-1)' : '');
    }
    requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    flights.forEach(function (f) { f.prev = null; });
    scheduleNext(1200);
    requestAnimationFrame(frame);
  }

  function stop(clear) {
    running = false;
    clearTimeout(timer);
    if (clear) {
      closeCard(false);
      target.hidden = true;
      active = null;
      flights.forEach(function (f) { f.el.remove(); });
      flights = [];
    }
  }

  /* ---- Reduced motion: still life ----------------------------------------- */

  var SPOTS = [
    { x: 0.14, y: 0.24, rot: -18 },
    { x: 0.86, y: 0.72, rot: 14 },
    { x: 0.86, y: 0.2, rot: 8 },
  ];

  function stillLife() {
    stop(true);
    if (root.clientWidth < 640) return;
    var W = root.clientWidth;
    var H = root.clientHeight;
    products.slice(0, SPOTS.length).forEach(function (p, i) {
      var pw = sizeFor(p) * 0.6;
      var el = makeButton(p, pw);
      stage.appendChild(el);
      var f = { p: p, el: el, pw: pw, paused: true, x: SPOTS[i].x * W, y: SPOTS[i].y * H, rot: SPOTS[i].rot, flip: false };
      el.style.transform = 'translate(' + f.x + 'px,' + f.y + 'px) rotate(' + f.rot + 'deg)';
      wire(f);
      flights.push(f);
    });
  }

  /* ---- Lifecycle ---------------------------------------------------------- */

  function mode() {
    if (REDUCED.matches) stillLife();
    else { stop(true); start(); }
  }

  document.addEventListener('hcl:state', mode);
  REDUCED.addEventListener('change', mode);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) flights.forEach(function (f) { f.prev = null; });
  });
  window.addEventListener('resize', function () {
    if (openFor) placeCard(openFor);
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      if (REDUCED.matches) return;
      if (entries[0].isIntersecting) start();
      else stop(false);
    }).observe(root);
  }

  mode();
})();
